import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {
  private resetSubject = new Subject<void>();

  /**
   * An observable that feature components can subscribe to, to be notified of a reset event.
   */
  public reset$ = this.resetSubject.asObservable();

  /**
   * Broadcasts a reset event to all listening components.
   */
  public triggerReset(): void {
    this.resetSubject.next();
  }
}